/* eslint-disable react/prop-types */
import ComposedViewInfiniteCarouselComponent from "./composed-view-infinite-carousel";

function ComposedViewInfiniteCarousel({
  title,
  subTitle,
  items,
  itemType,
  className,
}) {
  return (
    <ComposedViewInfiniteCarouselComponent
      title={title}
      subTitle={subTitle}
      items={items}
      itemType={itemType}
      className={className}
    />
  );
}

export default ComposedViewInfiniteCarousel;
